import { makeObservable, observable } from 'mobx';

import DataMixin from './DataMixin';

export default class PaginatedDataMixin<T, S> extends DataMixin<T, S> {
  @observable isLoading = false;

  @observable hasMore = false;

  constructor(rootStore: S, api: T) {
    super(rootStore, api);

    makeObservable(this);
  }

  reset(): void {
    super.reset();

    this.isLoading = false;
    this.hasMore = false;
  }
}
